import { useMemo } from 'react';
import { get } from 'lodash';
import {
  faCircleCheck as SuccesCircleIcon,
  faCircleInfo as ErrorCircleIcon,
  IconDefinition,
} from '@fortawesome/free-solid-svg-icons';
import { red, green } from '@mui/material/colors';

import { ItemTaskStatusType } from '~globals/types/enums';
import { Nullable } from '~globals/types';

interface ItemTaskStatusInfoItem {
  icon: Nullable<IconDefinition>;
  color: Nullable<string>;
  tooltipMessage: Nullable<string>;
}

type ItemTaskStatusList = {
  [state in ItemTaskStatusType]: ItemTaskStatusInfoItem;
};

export const useItemTaskStatusInfo = (
  statusId: ItemTaskStatusType,
): ItemTaskStatusInfoItem => {
  const stateList = useMemo<ItemTaskStatusList>(
    () => ({
      [ItemTaskStatusType.Pending]: {
        icon: null,
        color: null,
        tooltipMessage: null,
      },
      [ItemTaskStatusType.Success]: {
        icon: SuccesCircleIcon,
        color: green['500'],
        tooltipMessage: 'Correcto ',
      },
      [ItemTaskStatusType.Error]: {
        icon: ErrorCircleIcon,
        color: red['500'],
        tooltipMessage: 'Con error',
      },
    }),
    [],
  );

  const currentInfo = useMemo<ItemTaskStatusInfoItem>(
    () => get(stateList, statusId),
    [statusId, stateList],
  );

  return currentInfo;
};
